import * as React from 'react';

import { ChevronDownIcon, ChevronUpIcon } from '@coursera/cds-icons';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';
import { COACH_LABEL } from 'bundles/ai-coach-platform/components/patterns/popover/constants';
import { useQuickAccessContext } from 'bundles/ai-coach-platform/components/patterns/popover/context/quickAccessContext';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  selected?: boolean;
  open: boolean;
  disabled?: boolean;
};

/**
 * AskButton is a wrapper component on CoachButton with some style overrides used within SuggestedActionsPopover.
 */
const AskButton = ({ selected, ...props }: Props) => {
  const { referenceProps } = useQuickAccessContext();
  const { open, disabled, ...rest } = props;

  return (
    <CoachButton
      {...referenceProps}
      {...rest}
      aria-disabled={disabled}
      aria-label={_t('Ask #{coachLabel}', { coachLabel: COACH_LABEL })}
      variant="ghost"
      size="small"
      icon={open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      iconPosition="after"
    >
      {_t('Ask')}
    </CoachButton>
  );
};

export default AskButton;
